import { render, staticRenderFns } from "./CustomPages.vue?vue&type=template&id=285f6078&scoped=true"
import script from "./CustomPages.vue?vue&type=script&lang=js"
export * from "./CustomPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285f6078",
  null
  
)

export default component.exports